import { render, staticRenderFns } from "./AlertsEscalations.vue?vue&type=template&id=98b5ebe6&scoped=true"
import script from "./AlertsEscalations.vue?vue&type=script&lang=js"
export * from "./AlertsEscalations.vue?vue&type=script&lang=js"
import style0 from "./AlertsEscalations.vue?vue&type=style&index=0&id=98b5ebe6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b5ebe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98b5ebe6')) {
      api.createRecord('98b5ebe6', component.options)
    } else {
      api.reload('98b5ebe6', component.options)
    }
    module.hot.accept("./AlertsEscalations.vue?vue&type=template&id=98b5ebe6&scoped=true", function () {
      api.rerender('98b5ebe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/AlertsEscalations.vue"
export default component.exports